/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CData from 'components_v2/common/CData';
import Video from 'components/Video/VideoLoader';
import Link from 'components/Link';
import Image from 'components/Image';
import _get from 'lodash.get';
// import CounterWidigtsIframe from 'components/CounterWidigtsIframe';
// import OpenInAppWidget from 'components_v2/common/OpenInAppWidget';
import Quote from 'components_v2/common/Quote';
import ElectionWidget from 'components_v2/common/ElectionWidget';
// import NewscardComponent from 'components_v2/common/InitNewscardComponents/LoadableNewsCardComponent';
import WithNativeCampaign from 'helpers/ads/WithNativeCampaign';
import { isMrecAds } from 'helpers/ads/utils';
// import BudgetPdfDowloader from 'components/BudgetPdfDowloader';
import AdCaller from 'helpers/ads/adCaller';
// import { isTablet } from 'utils/common';
// import AffiliatesContent from 'components/AffiliatesContent';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen/PrimeScreen';
//import TimelinePoll from '../TimelinePoll';
import PollWidgetMain from 'components_v2/common/PollWidget/PollWidgetMain';
// import TimesAssist from 'components_v2/common/TimesAssist';
import Optawidget from 'components_v2/common/Optawidget';
// import ElementInView from 'components_v2/common/ElementInView';
// import { CARDS_ARTICLESHOW_JSON_URL_V2 } from 'constants/index';
// import InViewObserver from 'components/InViewObserver/InViewObserver';
import TextList from '../TextList';
import OptaWidgetInLine from '../OptaWidgetInLine';
import TimelineItemWrapper from '../TimelineItemWrapper';
import SliderWidgetWithModal from '../SliderWidgetWithModal/SliderWidgetWithModalLoader';
import TimelineImage from './items/TimelineImage';
import NotificationHooksWraper from '../NotificationHooksWraper';
import CricketItem from '../CricketItem';
import OverSummary from '../OverSummary';
import s from './Timeline.scss';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';
import { getGeoCountry } from '../../../../../utils/primeUtil';
import LoadableComponentLoader from '../../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';

// const responsive = [
//   {
//     breakpoint: 1368,
//     settings: {
//       slidesToShow: 2.5,
//     },
//   },
//   {
//     breakpoint: 767,
//     settings: {
//       slidesToShow: 1.1,
//     },
//   },
// ];
class Timeline extends React.Component {
  static getComponent(type, item) {
    const mapping = {
      m: () => <TimelineImage data={item} />,
    };
    return mapping[type];
  }

  // getReadNextWidget = position => {
  //   const { msid, cardsData, isWapView, isPrime } = this.props;
  //   return isPrime ? (
  //     <LoadableComponentLoader
  //       setReadNextApiFailEventTrigger={
  //         this.props.setReadNextApiFailEventTrigger
  //       }
  //       readNextApiFailEventCaptured={this.props.readNextApiFailEventCaptured}
  //       loadOnScroll
  //       loadableComponentName="NativeCard"
  //       isWapView={isWapView}
  //       position={position}
  //       datakey={msid}
  //       cardsResponseData={cardsData}
  //       slidesToShow={isWapView ? 1.1 : 3}
  //       eventCategory="liveblog"
  //       styles={nativeCardStyle}
  //       responsive={responsive}
  //     />
  //   ) : (
  //     ''
  //   );
  // };

  renderItem = (item, index, isSharedItem = false) => {
    const {
      isWapView,
      isGrid2Col,
      isLoggedIn,
      toggleLoginBox,
      fullPath,
      showSocialMsid,
      isAppView,
      // isUSGeo,
      url,
      title,
      affKeyword,
      matchStatus,
      navsubsecs: {
        subsec1: { subsecnameseo1 } = {},
        subsec2: { subsecnameseo2 } = {},
      } = {},
      // cardsInsertsLite,
      // location,
      // msid,
      // topicTree,
    } = this.props;
    let itemType = item.subtype ? item.subtype : item.tn || item.type || '';
    let timesassistData = null;
    if (this.props.timesassist) {
      timesassistData = this.props.timesassist.filter(
        ts => ts.tn === 'times_assist',
      );
      timesassistData =
        timesassistData &&
        Array.isArray(timesassistData) &&
        timesassistData.length &&
        timesassistData[0]?.data;
    }
    itemType = itemType.toLowerCase();
    const widgetType = item.type;
    if (
      ['twitter', 'facebook', 'instagram', 'reels-instagram'].indexOf(
        itemType,
      ) > -1
    ) {
      itemType = 'social';
    }

    let itemComponent;
    let isTimesWrapper = true;
    let forceNoWrapper = false;
    let classToApply = null;
    let showTitle = true;
    let isSocialconNeeded = true;
    const width = !isGrid2Col && !isWapView ? 700 : 500;
    const showImagedesc = true;

    switch (itemType) {
      case 'm':
        itemComponent = (
          <TimelineImage
            data={item}
            width={width}
            showImagedesc={showImagedesc}
          />
        );
        break;
      case 'social': {
        itemComponent = (
          <CData value={item.emcontent} type={item.subtype} /*pos={key}*/ />
        );
        break;
      }
      case 'v': {
        const slikeId = item.videoId ? item.videoId.trim() : '';
        itemComponent = (
          <Video
            duration={item.du}
            msid={item.msid}
            slikeId={slikeId}
            rmid={item.rmid}
            width={item.imageWidth || 685}
            imgsize={item.imgsize}
            videoClassName={`${s.TimelineVideo}`}
            iconClassName={s.VideoIcon_duration}
            videoClassInner={`${s.content}`}
            newga={`${
              this.props.gaCategory
            }#click#videoClick_${item.overridelink || item.msid}`}
            tmplSource="videoshow"
          />
        );
        break;
      }
      // case 'poll':
      //   showTitle = false;
      //   isSocialconNeeded = false;
      //   itemComponent = (
      //     <TimelinePoll
      //       data={item}
      //       toggleLoginBox={toggleLoginBox}
      //       isLoggedIn={isLoggedIn}
      //       isWapView={isWapView}
      //       newga={`${this.props.gaCategory}#click#poll_submit`}
      //       tpShow={false}
      //       url={url}
      //       sharingtitle={title}
      //       pollDone
      //     />
      //   );
      //   break;
      case 'poll':
        showTitle = false;
        isSocialconNeeded = false;
        itemComponent = (
          <PollWidgetMain
            data={[item]}
            key={`${item.tn}_${index}`}
            isLoggedIn={isLoggedIn}
            toggleLoginBox={toggleLoginBox}
            fallback={this.enableFallbackComponent}
            url={url}
            sharingtitle={title}
            isWapView={isWapView}
            tpShow={false}
          />
        );
        break;

      case 'quotes':
        showTitle = false;
        itemComponent = <Quote data={item} />;
        break;
      case 'appdll':
        // itemComponent =
        //   !isAppView && (isWapView || isTablet()) ? (
        //     <div className={`${s.insert_widgets}`} key={`${item.tn}_${index}`}>
        //       <OpenInAppWidget gaCategory={this.props.gaCategory} />
        //     </div>
        // <ElementInView
        //   gaLabel={url}
        //   gaCategory="TimesBetterIndiaPromo"
        //   gaAction="seen"
        // >
        //   <div className={s.timesbetter_banner}>
        //     <Link
        //       to="https://timesofabetterindia.com/big-picture-contest?utm_source=til&utm_medium=til&utm_campaign=toabi "
        //       data={{
        //         gaCategory: 'TimesBetterIndiaPromo',
        //         gaAction: 'click',
        //         gaLabel: url,
        //       }}
        //     >
        //       <img
        //         src="https://static.toiimg.com/photo/93291169.cms"
        //         alt=""
        //       />
        //     </Link>
        //   </div>
        // </ElementInView>
        // ) : null;
        isTimesWrapper = false;
        forceNoWrapper = true;
        break;
      case 'primeinlinewidget':
        itemComponent = !isAppView ? (
          <div
            className={`${s.insert_widgets} ${s.NoPadding} ${s.primehook}`}
            key={`${item.tn}_${index}`}
          >
            <PrimeScreen
              componentName="InlineWidget"
              isWapView={this.props.isWapView}
            />
          </div>
        ) : null;
        isTimesWrapper = false;
        break;
      case 'bundleshort':
        //   itemComponent =
        //     !isAppView && this.props.isPrime ? (
        //       <InViewObserver viewMargin="0px 0px 0px 0px">
        //         <div
        //           className={`${s.insert_widgets}`}
        //           key={`${item.tn}_${index}`}
        //         >
        //           {this.getReadNextWidget('above-bottom-of-article')}
        //           {this.getReadNextWidget('bottom-of-article')}
        //         </div>
        //       </InViewObserver>
        //     ) : null;
        itemComponent = null;
        break;
      case 'notificationhooks':
        itemComponent = !isAppView ? (
          <div className={`${s.insert_widgets}`} key={`${item.tn}_${index}`}>
            <NotificationHooksWraper
              data={item}
              isWapView={isWapView}
              gaCategory={this.props.gaCategory}
            />
          </div>
        ) : null;
        isTimesWrapper = false;
        break;
      // case 'covid19widgetinsert':
      //   if (!isUSGeo) {
      //     Object.defineProperty(item, 'url', {
      //       value: item.wu,
      //       height: item.height,
      //       writable: false,
      //     });
      //     itemComponent = (
      //       <div
      //         className={`${s.insert_widgets} ${s.covid}`}
      //         key={`${item.tn}_${index}`}
      //       >
      //         <CounterWidigtsIframe data={item} />
      //       </div>
      //     );
      //     isTimesWrapper = false;
      //   }
      //   break;
      // case 'budgetpdfwidget':
      //   itemComponent = (
      //     <BudgetPdfDowloader data={item.data} key={`${item.tn}_${index}`} />
      //   );
      //   isTimesWrapper = false;
      //   break;
      // case 'amazonsliderinsert':
      //   if (isUSGeo) {
      //     Object.defineProperty(item, 'url', {
      //       value: item.wu,
      //       height: item.height,
      //       writable: false,
      //     });
      //     itemComponent = (
      //       <div
      //         className={`${s.insert_widgets} ${s.amazonInsert}`}
      //         key={`${item.tn}_${index}`}
      //       >
      //         <CounterWidigtsIframe data={item} />
      //       </div>
      //     );
      //     isTimesWrapper = false;
      //   }
      //   break;
      case 'articleshowinsert': {
        let gaData = {};
        if (item.name === 'articleslide' || item.name === 'photoslide') {
          gaData = {
            category: this.props.gaCategory,
            action: 'click',
            label: item.name === 'articleslide' ? 'articleClick' : 'photoClick',
          };
        } else {
          gaData = {
            category: this.props.gaCategory,
            action: 'as_insert',
            label: 'story',
          };
        }
        const dataScrollGA =
          item.name === 'articleslide'
            ? 'scroll#as_insert_view'
            : 'scroll#ps_insert_view';
        itemComponent = !(isAppView && widgetType === 'spotlight') ? (
          <div
            className={`${s.insert_widgets}`}
            data-scrollga={dataScrollGA}
            key={`${item.tn}_${index}`}
          >
            <SliderWidgetWithModal
              {...item}
              isWapView={isWapView}
              gaData={gaData}
              usePopupPortal={this.props.usePopupPortal}
            />
          </div>
        ) : null;
        isTimesWrapper = false;
        break;
      }
      case 'banner': {
        itemComponent = !isAppView ? (
          <Link
            to={item.link}
            data-newga={item.ga || ''}
            target={item.target === '_blank' ? item.target : ''}
            className={s.bannerLink}
            key={`${item.tn}_${index}`}
          >
            <Image
              url={item.imgUrl}
              src={item.imgUrl}
              target="_blank"
              // width={width}
              title={item.title || ''}
              placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
              lazyload
            />
          </Link>
        ) : null;
        isTimesWrapper = false;
        break;
      }
      case 'videoinsert':
        itemComponent = (
          <div
            className={`${s.insert_widgets}`}
            data-scrollga="related_videos#view"
            key={`${item.tn}_${index}`}
          >
            <SliderWidgetWithModal
              {...item}
              isWapView={isWapView}
              gaData={{
                action: 'related_videos',
                label: 'video',
              }}
              usePopupPortal={this.props.usePopupPortal}
            />
          </div>
        );
        isTimesWrapper = false;
        break;
      case 'ad': {
        if (!this.props.isPrime) {
          let adWrapperClsName = '';
          let shimmerCls = '';
          if (!this.props.isPrime && this.props.isWapView) {
            try {
              adWrapperClsName = 'lblist';
              shimmerCls = 'phShimmer';
              if (!item.isCTN) {
                adWrapperClsName = `${adWrapperClsName} lbad_300by250`;
              }
            } catch (e) {
              // console.log(e)
            }
          }
          let name = 'native';
          if (!item.isCTN) {
            name = this.props.isWapView ? 'mrec' : 'mid1';
          }
          const adComp = (
            <div
              className={`${item.isCTN ? `${s.timeline_CTN_ads}` : s.LB_ads} ${
                !isGrid2Col ? s.col2 : ''
              } ${shimmerCls}`}
              data-scrollga={`scroll#ad_view_${index + 1}`}
              key={`${item.tn}_${index}`}
            >
              <AdCaller
                skipReRender
                data={{
                  ...item,
                  name,
                  msid: item.isCTN ? `${index}` : undefined,
                }}
                immediateLoad
                isCTN={item.isCTN}
                className={`${
                  item.isCTN
                    ? ''
                    : `${s.single} ${s.mrecads} ${adWrapperClsName}`
                } `}
                deviceType={this.props.isWapView ? 'mobile' : ''}
                key={`${item.tn}-${index}`}
              />
            </div>
          );
          //index to create separate msid props for CTN ad div
          //which uses msid to create data-position attribute, which should be unique
          if (isMrecAds(item)) {
            itemComponent = (
              <WithNativeCampaign type="mrecplusplus">
                {adComp}
              </WithNativeCampaign>
            );
          } else {
            itemComponent = adComp;
          }
          forceNoWrapper = true;
          /**
           * if not defined then initialize 1, then count till 2nd AD
           */
          if (!this.adDfpCounter) {
            this.adDfpCounter = 1;
          } else if (this.adDfpCounter < 2) {
            this.adDfpCounter = this.adDfpCounter + 1;
          }
        }
        break;
      }
      case 'ads': {
        if (!this.props.isPrime) {
          itemComponent = (
            <div
              className={s.LB_ads}
              data-scrollga={`scroll#ad_view_${index + 1}`}
              key={`${item.tn}_${index}`}
            >
              {item.data.map((ad, adIndex) => (
                <AdCaller
                  data={{
                    ...ad,
                    msid: ad.isCTN ? `${index}` : undefined,
                  }}
                  isCTN={ad.isCTN}
                  className={`${s.mrecads} ${s.double}`}
                  deviceType={this.props.isWapView ? 'mobile' : ''}
                  key={`${item.tn}-${index}-${adIndex}`}
                />
              ))}
            </div>
          );
          forceNoWrapper = true;
        }
        break;
      }
      case 'cricket': {
        const battingTeam =
          this.props.timelineData &&
          this.props.timelineData.metaInfo &&
          this.props.timelineData.metaInfo.battingTeam;
        const { specialClass } = this.props;
        const oversummary = item && item.oversummary ? item.oversummary : '';
        // const bowlingTeam =
        //   this.props.timelineData &&
        // this.props.timelineData.metaInfo &&
        // this.props.timelineData.metaInfo.bowlingTeam;
        itemComponent = (
          <>
            {oversummary && (
              <OverSummary
                data={oversummary}
                over={item?.overs}
                runs={item?.totalRuns}
                wickets={item?.totalWickets}
                specialClass={specialClass}
              />
            )}
            <CricketItem
              battingTeam={battingTeam}
              key={`${item.tn}_${index}`}
              data={item}
            />
          </>
        );
        break;
      }
      case 'dailytop10newsletter': {
        itemComponent = (
          <ElectionWidget
            key={`${item.tn}_${index}`}
            item={item}
            ExternalClass={`${s.widgetonsportsliveblog} `}
            InternalClass="formWidth"
            gaLabel="newsletter_view"
            gaAction="scroll"
            gaCategory={this.props.gaCategory}
            disappearLetter
          />
        );
        isTimesWrapper = false;
        break;
      }
      case 'aff_timeline_insert': {
        itemComponent = this.props.isMobile && (
          <AffiliatesContentV2
            type="toi_widget_slots"
            client="affiliates"
            filters={{
              pagename: 'liveblog',
              keyword: affKeyword,
              sectionl1: subsecnameseo1,
            }}
            componentProps={{
              config: {
                // affiliateName,
                ga4: {
                  section: subsecnameseo1,
                  subsection: subsecnameseo2,
                },
              },
            }}
            key={`${item.tn}_${index}`}
            className={`${s.aff_timeline_insert} ${
              !this.props.isMobile && !isGrid2Col ? s.aff_timeline_col2 : ''
            }`}
          />
        );
        isTimesWrapper = false;
        forceNoWrapper = true;
        break;
      }
      case 'affiliate_iframe': {
        itemComponent = null;
        //#todo remove this case, when affiliate_iframe is removed from feed.
        break;
      }
      case 'optawidget': {
        classToApply = 'optawidgetoverwrite';
        // TOIPR-65769 : remove opta when match over
        const matchEnded =
          matchStatus &&
          matchStatus.matchStatus &&
          matchStatus.matchStatus.toLowerCase() === 'match ended';
        itemComponent =
          (item &&
            item.MigrationId &&
            item.SupplementaryContentId &&
            item.DeviceId &&
            !matchEnded && (
              <OptaWidgetInLine
                competition={item.MigrationId}
                season={item.SupplementaryContentId}
                match={item.DeviceId}
                gaCategory={this.props.gaCategory}
                isWapView={isWapView}
                matchStatus={matchStatus}
                displayTabs={false}
                onOptaWidgetInlineLoad={this.props.onOptaWidgetInlineLoad}
              >
                {props => <Optawidget {...props} />}
              </OptaWidgetInLine>
            )) ||
          null;
        break;
      }
      default: {
        itemComponent = <TextList data={item} itemIndex={index} />;
      }
    }
    if (
      (!this.props.showToiPlusNudges && itemType === 'primeinlinewidget') ||
      !itemComponent
    ) {
      return null;
    }
    // const bannerComp = null;
    // if (!isWapView && index === 9) {
    //   bannerComp = (
    //     <div className={s.timesbetter_banner}>
    //       <Link
    //         target="_blank"
    //         to="https://timesofabetterindia.com/big-picture-contest?utm_source=til&utm_medium=til&utm_campaign=toabi "
    //         data={{
    //           gaCategory: 'TimesBetterIndiaPromo',
    //           gaAction: 'click',
    //           gaLabel: url,
    //         }}
    //       >
    //         <img src="https://static.toiimg.com/photo/93291203.cms" alt="" />
    //       </Link>
    //     </div>
    //   );
    // }
    let sponsorLead = '';
    let sponsorLogo = '';
    let sponsorUrl = '';
    if (item && item.metainfo && item.metainfo.LiveBlogFilter) {
      const liveBlogFilter = item.metainfo.LiveBlogFilter.toLowerCase();
      if (this.props.snippetSponsorMapping[liveBlogFilter]) {
        const mappedSponsor = this.props.snippetSponsorMapping[liveBlogFilter];
        sponsorLead =
          mappedSponsor.decode && mappedSponsor.decode.toUpperCase();
        sponsorLogo = mappedSponsor.sponsor_logo_url;
        sponsorUrl = mappedSponsor.sponsor_url;
      }
    }
    let finalComponent = (
      <>
        <TimelineItemWrapper
          data={isTimesWrapper ? item : {}}
          isWapView={isWapView}
          isGrid2Col={isGrid2Col}
          isSocialShare={!isAppView && isTimesWrapper && isSocialconNeeded}
          showTitle={showTitle}
          fullPath={fullPath}
          isSharedItem={isSharedItem}
          index={index}
          key={item.msid || `${item.tn}_${index}`}
          showSocialMsid={showSocialMsid}
          gaIndex={index}
          utm={this.props.utm || ''}
          gaCategory={this.props.gaCategory}
          className={classToApply || ''}
          sponsorLead={sponsorLead}
          sponsorLogo={sponsorLogo}
          sponsorUrl={sponsorUrl}
        >
          {itemComponent}
        </TimelineItemWrapper>
        {!isWapView &&
          index === 0 &&
          !!timesassistData &&
          (this.props.isPrime || isLoggedIn) &&
          getGeoCountry() === 'IN' && (
            <div className={`${s.timesAssistBox} ${!isGrid2Col ? s.col2 : ''}`}>
              <ErrorBoundary>
                <LoadableComponentLoader
                  loadInView
                  loadableComponentName="TimesAssist"
                  data={timesassistData}
                  isUserLoggedin={isLoggedIn}
                  pageUrl={this.props.url}
                  isUserPrime={this.props.isPrime}
                />
              </ErrorBoundary>
            </div>
          )}
        {/* {!isWapView &&
          index === 9 && (
            <ElementInView
              gaLabel={url}
              gaCategory="TimesBetterIndiaPromo"
              gaAction="seen"
            >
              {bannerComp}
            </ElementInView>
          )} */}
      </>
    );
    if (forceNoWrapper || (!isTimesWrapper && isWapView)) {
      finalComponent = itemComponent;
    }
    if (typeof this.scrollAnchorIndex === 'undefined') {
      this.scrollAnchorIndex = 0;
    }
    /**
     * start counting only when we have encountered two ADs
     */
    if (this.adDfpCounter === 2) {
      this.scrollAnchorIndex += 1;
    }
    /**
     * place after 2nd MREC + 2 Timeline Items, i.e, 3 count
     */

    return this.scrollAnchorIndex === 3 && this.props.withScrollAnchor ? (
      <>
        {finalComponent}
        <div key={`${this.scrollAnchorIndex}_${index}`} id="_scrollanchor_" />
      </>
    ) : (
      finalComponent
    );
  };
  shouldComponentUpdate(nextProps) {
    if (
      nextProps.hideNotification !== this.props.hideNotification &&
      this.props.updatedContents &&
      nextProps.updatedContents.length === this.props.updatedContents.length &&
      nextProps.isLoggedIn === this.props.isLoggedIn
    ) {
      return false;
    }
    return true;
  }

  renderSharedItem = item => <div>{this.renderItem(item, null, true)}</div>;
  render() {
    this.scrollAnchorIndex = 0;
    this.adDfpCounter = 0;
    const { updatedContents } = this.props;
    let items;
    if (updatedContents instanceof Array) {
      let currentIndex = 0;
      items = updatedContents.map((item, index) => {
        if (item.type === 'em' || item.type === 't') {
          currentIndex += 1;
        } else {
          currentIndex = index;
        }
        return this.renderItem(item, currentIndex);
      });
    }

    return (
      <React.Fragment>
        {this.props.sharedItem && this.renderSharedItem(this.props.sharedItem)}
        {items}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  matchStatus: state?.cricketScorecard?.matchStatus,
  cardsData: _get(state, 'readnextbundle.readNextCards', {}),
  isMobile: _get(state, 'isMobile', false),
});

Timeline.propTypes = {
  updatedContents: PropTypes.shape([]).isRequired,
  isWapView: PropTypes.bool,
  isGrid2Col: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  toggleLoginBox: PropTypes.func,
  msid: PropTypes.number.isRequired,
  fullPath: PropTypes.string,
  isAppView: PropTypes.bool,
  isUSGeo: PropTypes.bool,
  usePopupPortal: PropTypes.bool,
  showToiPlusNudges: PropTypes.bool,
  affKeyword: PropTypes.string,
  navsubsecs: PropTypes.shape({}),
  matchStatus: PropTypes.shape({}),
  onOptaWidgetInlineLoad: PropTypes.func,
  snippetSponsorMapping: PropTypes.shape({}),
  isPrime: PropTypes.bool,
  withScrollAnchor: PropTypes.bool,
  isMobile: PropTypes.bool,
  specialClass: PropTypes.string,
};

Timeline.defaultProps = {
  isWapView: false,
  isGrid2Col: false,
  isLoggedIn: false,
  toggleLoginBox: () => {},
  fullPath: '',
  isAppView: false,
  isUSGeo: false,
  usePopupPortal: false,
  showToiPlusNudges: false,
  affKeyword: undefined,
  navsubsecs: undefined,
  matchStatus: undefined,
  onOptaWidgetInlineLoad: () => {},
  snippetSponsorMapping: {},
  isPrime: false,
  withScrollAnchor: false,
  isMobile: false,
  specialClass: '',
};

export default connect(mapStateToProps)(Timeline);
